import React, { useEffect, useState } from "react";
// import SideBar from "./SideBar";

// import FileUpload from "./FileUpload";
import { useDispatch } from "react-redux";
// import { getSubtitles } from "../../thunks/editor/scriptThunks";
import SideBar from "./Sidebar";
import FileUpload from "../../subtitle/FileUpload";
import {
  LANGUAGE_DATA,
  languageDubbingArray,
} from "../../../constants/scriptConfig";
import { setTargetLanguage } from "../../../store/AiDubbing/AiDubbingSlice";
import { useSelector } from "react-redux";
import { setSelectedVideo } from "../../../store/Subtitle/subTitleSlice";
import { getFromLocal } from "../../../utils/localStorage";
import { createAIDubbingVideo } from "../../../thunks/aiDubbing/aiDubbingThunk";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { showToast } from "../../../utils/general";
import { Tooltip } from "../../common/Tooltip";

const AiVideoPopover = () => {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(0);
  const [stage, setStage] = useState(0);
  // const { id } = useSelector((state) => state.project);
  // const { id } = useParams();
  const navigate = useNavigate();
  const onUpload = (file) => {
    dispatch(setSelectedVideo(file));
    setSelectedTab(0);
  };
  const { target_language, selectedVideo = null } = useSelector(
    (state) => state.aiDubbing
  );

  return (
    <div className="flex">
      <SideBar selectedTab={selectedTab} setSelectedTab={setSelectedTab} />

      <div className="bg-[#F4F3F6] h-[400px] w-[500px] p-[10px] pt-5">
        {stage === 0 && (
          <>
            <div className="font-semibold text-sm	text-[#11142DB2] pb-[11px]">
              Upload Video
            </div>
            <div className="pt-[30px]">
              <FileUpload
                onUpload={onUpload}
                accept="video/*"
                aiDubbing={true}
                maxSize={30}
              />
            </div>
            <div
              className={`absolute bottom-0 right-0 flex justify-end pr-[15px] pb-[15px] pt-[11px] pl-[26px]`}
            >
              <button
                className={` ${
                  !selectedVideo ? "bg-gray-600 cursor-not-allowed" : ""
                } relative inline-flex items-center  lg:mt-0 xl:mt-0 px-1 xl:px-4 py-2 border border-transparent text-xs lg:text-[10px] xl:text-sm font-medium rounded-md shadow-sm text-white bg-black hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 group`}
                onClick={() => setStage(1)}
              >
                {!selectedVideo && (
                  <Tooltip>{"Please Select Video First"}</Tooltip>
                )}
                Next
              </button>
            </div>
          </>
        )}

        {stage === 1 && (
          <>
            <div className="w-full px-2 py-2 text-sm bg-gray-200 text-gray-700 flex items-center">
              <FontAwesomeIcon
                icon={faArrowLeft}
                onClick={() => setStage(0)}
                className="mr-2 p-1 h-4 border-gray-500 border rounded-lg cursor-pointer"
              />
              <span
                className="text-gray-500 cursor-pointer"
                onClick={() => setStage(0)}
              >
                BACK{" "}
              </span>
            </div>

            <div className="font-semibold text-sm	text-[#11142DB2] pb-[11px]">
              Targeted language
              <div>
                <select
                  className="p-2 rounded mt-2 border w-fit"
                  defaultValue={target_language}
                  onChange={(e) => dispatch(setTargetLanguage(e.target.value))}
                >
                  {languageDubbingArray.map((language) => (
                    <option key={language} value={language.code}>
                      {language.name}
                    </option>
                  ))}
                </select>
              </div>
              <button
                className="inline-flex items-center px-4 py-2 border border-black text-xs lg:text-sm font-medium rounded-md shadow-sm text-black bg-transparent hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 absolute bottom-4 right-4"
                onClick={() => showToast("Video Has been upload successFully")}
                disabled={!target_language && !selectedVideo}
              >
                Generate AI Dubbing Video
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AiVideoPopover;
